var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$.custom_columns_list,
      style: _vm.showStub ? { padding: 0 } : "",
    },
    [
      _vm.showStub
        ? _c("div", { class: _vm.$.stub }, [
            _c(
              "div",
              { class: _vm.$.wrapper },
              [
                _c("vgp-svg-image", { attrs: { name: "columns-bar-empty-1" } }),
                _vm._v(" "),
                _c("div", {
                  class: _vm.$.desc,
                  domProps: { innerHTML: _vm._s(_vm.stubDescription) },
                }),
              ],
              1
            ),
          ])
        : _c(
            "div",
            { ref: "columnsList", class: [_vm.$.list, "gantt_scroll"] },
            _vm._l(_vm.columns, function (item, index) {
              return _c(
                "div",
                { key: index, attrs: { "data-id": item.columnId } },
                [
                  _c("div", { class: _vm.$.row }, [
                    _c(
                      "div",
                      { class: _vm.$.row__icon },
                      [
                        _c("svg-sprite", {
                          attrs: {
                            name: item.icon.name,
                            type: item.icon.type,
                            size: item.icon.size,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { class: _vm.$.row__name }, [
                      _vm._v(
                        "\n          " + _vm._s(item.value) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: _vm.$.row__right },
                      [
                        _vm.isEditable &&
                        _vm.customColumnsAccountAccess &&
                        !_vm.isArchived
                          ? _c("div", { class: _vm.$.buttons }, [
                              _vm.customColumnsEditAccess
                                ? _c(
                                    "div",
                                    { class: _vm.$.buttons__edit },
                                    [
                                      _c("icon-button", {
                                        attrs: {
                                          id: "gp_autotest_columns_bar_edit",
                                          icon: { name: "pensil", size: 20 },
                                          size: "small",
                                        },
                                        on: {
                                          onClick: function ($event) {
                                            return _vm.onEditClick(item)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.customColumnsRemoveAccess
                                ? _c(
                                    "div",
                                    { class: _vm.$.buttons__delete },
                                    [
                                      _c("icon-button", {
                                        attrs: {
                                          id: "gp_autotest_columns_bar_delete",
                                          icon: { name: "delete", size: 20 },
                                          size: "small",
                                        },
                                        on: {
                                          onClick: function ($event) {
                                            return _vm.onDeleteClick(item)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.tooltip
                          ? _c("tooltip", {
                              class: _vm.$.tooltip,
                              attrs: {
                                position: "top-end",
                                content: item.tooltip,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function () {
                                      return [
                                        _c("svg-sprite", {
                                          attrs: { name: "info" },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: _vm.$.checkbox },
                          [
                            _c("vgp-checkbox", {
                              attrs: { size: 16, checked: item.enabled },
                              on: {
                                onChange: function ($event) {
                                  return _vm.onChange($event, item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.showFooter
        ? _c(
            "div",
            { class: _vm.$.footer },
            [
              _vm.showPricingUpgradeButton
                ? _c("upgrade-button", { attrs: { feature: "custom_fields" } })
                : _vm.showAssignButtons
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          style: _vm.allColumns.length
                            ? { marginBottom: "12px" }
                            : {},
                        },
                        [
                          _c("vgp-button", {
                            class: _vm.$.button,
                            attrs: {
                              id: "gp_autotest_columns_bar_add_new_column",
                              label: _vm.locale("columns_bar_add_new_column"),
                              type: "primary-border",
                              icon: { name: "plus-1", type: "bold", size: 24 },
                              "icon-side": "left",
                            },
                            on: { onClick: _vm.onCreateNewColumnClick },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.allColumns.length
                        ? _c("vgp-button", {
                            class: _vm.$.button,
                            attrs: {
                              id: "gp_autotest_columns_bar_use_existed",
                              label: _vm.locale("columns_bar_use_existed"),
                              type: "primary-border",
                              icon: { name: "change", type: "bold", size: 24 },
                              "icon-side": "left",
                            },
                            on: { onClick: _vm.onUseExistedColumnClick },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }